import React, { useState, useEffect, Fragment, useRef, useMemo } from 'react';
import Icon from '../components/Icon';
import { Search as SearchIcon } from 'react-feather';
import Dialog from '../components/Dialog';
import RichContent from '../components/RichContent';
import Image from '../components/Image';
import RadioGroup from './RadioGroup';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './colorList.module.css';
import RalColors from './ralColors';
/**
 * ColorList
 *
 * @typedef ColorList
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a configurator
 */
const ColorList = props => {
    const {
        colors,
        ral,
        selected,
        onChange,
        info,
        selectedCase,
        sectionDisabled,
        productDiscount
    } = props;
    const classes = useStyle(defaultClasses, props.classes);

    console.log('XXXX COLORLIST', colors, selectedCase, selected);

    const colorListsRefs = useRef({});

    const [currentColorCodeOpen, setCurrentColorCodeOpen] = useState(null);
    const [currentColorKey, setCurrentColorKey] = useState(null);

    const hideColorInfo = e => {
        e.preventDefault && e.preventDefault();
        setCurrentColorCodeOpen(null);
        setCurrentColorKey(null);
    };

    const ralColors = [
        {
            title: 'RAL Gladde lak +21%',
            type: 'ral-21',
            list: ral.map(item => ({
                ...item,
                techlabel: `RAL-${item.code}-GLADDE`,
                type: 'ral-21',
                price: '21%',
                additional: ' (gladde lak)'
            }))
        },
        {
            title: 'RAL Structuur lak +27%',
            type: 'ral-27',
            list: ral.map(item => ({
                ...item,
                techlabel: `RAL-${item.code}-STRUCTUUR`,
                type: 'ral-27',
                price: '27%',
                additional: ' (structuur lak)'
            }))
        }
    ];

    const colorsBlock = Object.keys(colors)
        .map((key, index) => {
            // don't print color list if no color list for the current case
            if (
                selectedCase &&
                !(colors[key].items instanceof Array) &&
                !colors[key].items['kast_type-' + selectedCase]
            ) {
                return null;
            }

            const colorList =
                colors[key].items instanceof Array
                    ? colors[key].items
                    : Object.values(
                          colors[key].items['kast_type-' + selectedCase] || {}
                      );

            if (!colorList.length) {
                return null;
            }

            const radioName = `color-${key}`;

            // Create a ref for this RadioGroup if it doesn't already exist
            if (!colorListsRefs.current[key]) {
                colorListsRefs.current[key] = React.createRef();
            }

            console.log('Configurator prices key', key);
            console.log('colorList', colorList);

            colorList.map(item => {
                //                const showInfoBlock = !!(item.label && (item.thumb || item.image) && item.doc);
                const showInfoBlock = true;

                if (!showInfoBlock) {
                    return;
                }

                const infoBlock = (
                    <Icon
                        src={SearchIcon}
                        attrs={{ width: 24 }}
                        alt={_('Información sobre este color')}
                        onClick={() => {
                            setCurrentColorCodeOpen(item.code);
                            setCurrentColorKey(key);
                        }}
                        className={classes.infocolor}
                    />
                );

                item.infoblock = infoBlock;
            });

            const selectedColor =
                (selected instanceof Map ? selected.get(key) : selected[key]) ||
                null;

            return (
                <Fragment key={key}>
                    <h2>{colors[key].label}</h2>
                    <div
                        className={classes.colorlist}
                        ref={colorListsRefs.current[key]}
                    >
                        <RadioGroup
                            field={radioName}
                            fieldState={{ value: selectedColor }}
                            initialValue={selectedColor}
                            name={radioName}
                            items={colorList}
                            classes={classes}
                            onValueChange={e => {
                                return onChange(e, key);
                            }}
                            key={key}
                            radioGroupName={key}
                        />
                        {ral.length &&
                            key == 'kast_geleiders' &&
                            ralColors.map(({ title, type, list }) => (
                                <RalColors
                                    key={type}
                                    title={title}
                                    type={type}
                                    colors={list}
                                    initialValue={selectedColor}
                                    onColorSelected={ralColor => {
                                        // const ralCode = `RAL${ralColor.code}`;
                                        onChange(
                                            {
                                                ...ralColor,
                                                label:
                                                    ralColor.label +
                                                    ralColor.additional
                                            },
                                            key
                                        );

                                        setTimeout(() => {
                                            const currentChecked = colorListsRefs.current[
                                                key
                                            ].current.querySelector(':checked');

                                            if (currentChecked) {
                                                currentChecked.checked = false;
                                            }
                                        }, 10);
                                    }}
                                />
                            ))}
                    </div>
                </Fragment>
            );
        })
        .filter(block => !!block);

    const [isInfoOpen, setIsInfoOpen] = useState(false);

    const showInfo = e => {
        e.preventDefault && e.preventDefault();
        setIsInfoOpen(true);
    };

    const hideInfo = e => {
        e.preventDefault && e.preventDefault();
        setIsInfoOpen(false);
    };

    const [colorDialogContent, setColorDialogContent] = useState(null);

    useEffect(() => {
        if (!currentColorCodeOpen) {
            setColorDialogContent(null);
            return;
        }

        const colorList =
            colors[currentColorKey].items instanceof Array
                ? colors[currentColorKey].items
                : Object.values(
                      colors[currentColorKey].items[
                          'kast_type-' + selectedCase
                      ] || {}
                  );

        // find the color data by the color code
        const colorItem = colorList.find(
            item => item.code == currentColorCodeOpen
        );

        if (!colorItem) {
            setColorDialogContent(null);
            return;
        }

        const thumbUrl = colorItem.thumb
            ? colorItem.thumb.match(/^http/)
                ? colorItem.thumb
                : process.env.MAGENTO_BACKEND_URL + colorItem.thumb
            : null;
        const imageUrl = colorItem.image
            ? colorItem.image.match(/^http/)
                ? colorItem.image
                : process.env.MAGENTO_BACKEND_URL + colorItem.image
            : null;

        const colorDemo =
            thumbUrl || imageUrl ? (
                <Image
                    resource={thumbUrl || imageUrl}
                    width={500}
                    height={500}
                    alt={colorItem.label}
                    ratio={1}
                    padding={0}
                    classes={{ container: classes.pattern }}
                />
            ) : (
                <span
                    className={classes.demo}
                    style={{ backgroundColor: colorItem.value }}
                />
            );
        //        const styles = {};
        //        color && (styles.backgroundColor = color);
        // method at() is not yet supported in Safari and other dinosaur browsers
        // const docname = item.doc.split('/').at(-1);
        const docname = colorItem.doc && colorItem.doc.split('/').splice(-1)[0];

        const colorPriceToDisplay =
            productDiscount > 0
                ? colorItem.price - colorItem.price / (100 / productDiscount)
                : colorItem.price;

        // prefix price with "+" for positive prices and not already prefixed
        const colorPrice =
            parseInt(colorPriceToDisplay) > 0 &&
            (colorPriceToDisplay + '')[0] !== '+'
                ? '+' + colorPriceToDisplay
                : colorPriceToDisplay;

        const dialog = (
            <Dialog
                isOpen={currentColorCodeOpen}
                onConfirm={e => {
                    // dirty way to select the color
                    document
                        .getElementById(
                            `radio-${currentColorKey}-${currentColorCodeOpen}`
                        )
                        .click();
                    hideColorInfo(e);
                }}
                onCancel={hideColorInfo}
                cancelText={_('Close')}
                confirmText={_('Choose this color')}
                showCancelButton={true}
                classes={{ contents: classes.dialog }}
            >
                {colorDemo}
                <div className={classes.colorinfo}>
                    <p
                        className={
                            classes.colorInfoRow +
                            ' ' +
                            (classes.labelContainer || '')
                        }
                    >
                        {colorItem.label}
                    </p>
                    <p
                        className={
                            classes.colorInfoRow +
                            ' ' +
                            (classes.codeContainer || '')
                        }
                    >
                        {_('Color code')}: <strong>{colorItem.code}</strong>
                    </p>
                    {colorItem.price ? (
                        <p
                            className={
                                classes.colorInfoRow +
                                ' ' +
                                (classes.priceContainer || '')
                            }
                        >
                            {_('Price')}: <strong>{colorPrice}</strong>
                        </p>
                    ) : null}
                    {colorItem.doc ? (
                        <p
                            className={
                                classes.colorInfoRow +
                                ' ' +
                                (classes.documentContainer || '')
                            }
                        >
                            <a
                                href={colorItem.doc}
                                download={docname}
                                target="_blank"
                                className={classes.downloadLink}
                            >
                                {_('Technical sheet')}
                            </a>
                        </p>
                    ) : null}
                </div>
            </Dialog>
        );

        setColorDialogContent(dialog);
    }, [currentColorCodeOpen, currentColorKey, selectedCase]);

    return colorsBlock.length ? (
        <Fragment>
            <fieldset className={classes.section} disabled={sectionDisabled}>
                <legend className={classes.grouptitle}>
                    {_('Elige un color')}
                    {info ? (
                        <span
                            onClick={showInfo}
                            className={classes.info}
                            title={_('Información sobre los colores')}
                        >
                            👁 {_('Read')} {_('Información sobre los colores')}
                        </span>
                    ) : null}
                </legend>
                <div className={classes.colorwrapper}>{colorsBlock}</div>
                {info ? (
                    <Dialog
                        isOpen={isInfoOpen}
                        onConfirm={hideInfo}
                        onCancel={hideInfo}
                        showCancelButton={false}
                        confirmText={_('Close')}
                        title={info.title}
                    >
                        <RichContent html={info.text} />
                    </Dialog>
                ) : null}
            </fieldset>
            {colorDialogContent}
        </Fragment>
    ) : null;
};

/*
 ColorList.propTypes = {
 clases: shape({
 root: string,
 icon: string
 }),
 title: string,
 text: string,
 buttonTitle: string,
 buttonText: string
 };
 */
export default ColorList;
